import { render } from "./App.ce.vue?vue&type=template&id=5e083270"
import script from "./App.ce.vue?vue&type=script&lang=js"
export * from "./App.ce.vue?vue&type=script&lang=js"

import _style_0 from "@/assets/init.css?vue&type=style&index=0&inline&lang=css"

import exportComponent from "D:\\di_lam\\fchat.vn\\fchat-_main_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__